/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DataPlanTimespan { 
    data: DataPlanTimespan.DataEnum;
    endDate?: string;
    startDate?: string;
}
export namespace DataPlanTimespan {
    export const DataEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataEnum = typeof DataEnum[keyof typeof DataEnum];
}


